import en from "./en.json";
import pl from "./pl.json";
import de from "./de.json";

export const translations = { en, pl, de };

export const languageOptions = [
  { code: "en", flag: "gb" },
  { code: "pl", flag: "pl" },
  { code: "de", flag: "de" },
];
